import { Box, CircularProgress } from '@mui/material';
import React from 'react';

interface LoadingWheelProps {
  size?: number;
}

const LoadingWheel: React.FC<LoadingWheelProps> = ({ size = 40 }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '200px',
      }}
    >
      <CircularProgress size={size} />
    </Box>
  );
};

export default LoadingWheel;
